/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Tabs_ProfileInputs */

const he_account_tabs_profile = /** @type {(inputs: Account_Tabs_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרופיל`)
};

const en_account_tabs_profile = /** @type {(inputs: Account_Tabs_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Account_Tabs_ProfileInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_tabs_profile = /** @type {((inputs?: Account_Tabs_ProfileInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Tabs_ProfileInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_tabs_profile(inputs)
	return en_account_tabs_profile(inputs)
});